export default "__VITE_ASSET__BUJy3bPo__"